import React, { Component } from 'react'
import { Table, Layout } from 'antd'
import {goodsLog} from '_src/api/api'
import moment from 'moment'

export default class GoodLogList extends Component {
  constructor (props) {
    super(props)
    this.id = props.id || ''
    this.state = {
      isLoading: false,
      createModelVisible: false,
      
      list: [],

      params: {
        pageNum: 0,
        pageSize: 10,
      },

      pageData: {
        total: 0, 
        current: 1, 
      },
      banDate: [],
      columns: [
        {
          title: <span>编号</span>,
          align: 'center',
          dataIndex: 'id',
          key: 'id',
        },
        // {
        //   title: <span>产品名称</span>,
        //   dataIndex: 'goodsName',
        //   align: 'center',
        // },
        // {
        //   title: <span>规格</span>,
        //   dataIndex: 'specifications',
        //   align: 'center',
        // },
        {
          title: <span>赠送积分</span>,
          align: 'center',
          dataIndex: 'reward',
        },
        {
          title: <span>上下架</span>,
          align: 'center',
          render: item => <div>
            <div>原：{item.beforeStatus === 1 ? '上架中' : '下架中'}</div>
            <div>现：{item.nowStatus === 1 ? '上架中' : '下架中'}</div>
          </div>,
        },
        {
          title: <span>操作信息</span>,
          render: item => <div>
            <div>操作人：{item.modifier}</div>
            <div>操作时间：{moment(item.createAt).format('YYYY-MM-DD HH:mm:ss')}</div>
          </div>,
        },
      ]
    }
  }

  componentDidMount () {
    const {params} = this.state
    this.loadList(this.id, params)
  }

  loadList (id, params) {
    this.setState({isLoading: true})
    goodsLog(id, params)
      .then(res => {
        this.setState({
          list: res.data.content,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
            total: 0,
            pageSize: 0,
          },
        })
      })
  }

  // 分页
  onPageChange = (e) => {
    const {params} = this.state
    params.pageNum = e.current - 1
    this.loadList(this.id, params)
  }

  render () {
    const {
      isLoading, 
      list, 
      columns, 
      pageData, 
    } = this.state

    return (
      <Layout className="goodType-page" style={{ padding: 20, backgroundColor: 'white' }}>
        <Table
          columns={columns}
          dataSource={list}
          loading = {isLoading}
          bordered
          rowKey="id"
          pagination={{
            current: pageData.current,
            total: pageData.total,
            pageSize: pageData.pageSize,
          }}
          onChange={this.onPageChange}
        />
      
      </Layout>
    )
  }
}